import {
  DataCardContainer,
  Footer,
  MainValue,
  Quantifier,
  Quantity,
  Title
} from './datacard-styles'

interface DataCardContentValues {
  mainValue: string
  quantifier?: string
  quantity?: string
}

export type DataCardProps = {
  id: string
  title?: string
  content: DataCardContentValues
  footer?: string
  redCard?: boolean
}

const DataCard = ({ id, title, content, footer, redCard = false }: DataCardProps) => {
  const { mainValue, quantifier, quantity } = content
  return (
    <DataCardContainer data-testid={`data-card-${id}`} isRedCard={redCard}>
      {title && <Title data-testid="title">{title}</Title>}
      {mainValue && <MainValue data-testid="main-value">{mainValue}</MainValue>}
      {quantifier && <Quantifier data-testid="quantifier">{quantifier}</Quantifier>}
      {quantity && <Quantity data-testid="quantity">{quantity}</Quantity>}
      {footer && <Footer data-testid="footer">{footer}</Footer>}
    </DataCardContainer>
  )
}

export default DataCard
